import React, { useEffect, useState } from "react";
import {
  SupportTrendChartAmount,
  SupportTrendChartNumber,
} from "./SupportTrendChart";
import { getPaymentTrendByCategory } from "common/services/payments.service";
import useQueryState from "Components/Hooks/UseQueryState";
import { FilterType, defaultFilter } from "pages/Reports/Filters";

const convertToCategoriesAndSeries = (data: any[]) => {
  // Extract unique years for the categories array
  const categories = Array.from(new Set(data.map((item) => item.year)));

  // Extract unique categories for the series names
  const uniqueCategories = Array.from(
    new Set(data.map((item) => item.category))
  );

  // Create countSeries
  const countSeries = uniqueCategories.map((category) => {
    return {
      name: category,
      data: categories.map((year) => {
        const entry = data.find(
          (item) => item.year === year && item.category === category
        );
        return entry ? entry.count : 0; // Default to 0 if no data exists
      }),
    };
  });

  // Create amountSeries
  const amountSeries = uniqueCategories.map((category) => {
    return {
      name: category,
      data: categories.map((year) => {
        const entry = data.find(
          (item) => item.year === year && item.category === category
        );
        return entry ? entry.totalAmount : 0; // Default to 0 if no data exists
      }),
    };
  });

  return { categories, countSeries, amountSeries };
};

const SupportTrend = ({ activeTab }: { activeTab: string }) => {
  const [filter] = useQueryState<FilterType>("filter", defaultFilter);

  const [payments, setPayments] = useState([]);
  const [, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response: any = await getPaymentTrendByCategory({});

        setPayments(response);
      } catch (error) {
        console.warn("Error fetching total  support", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    filter?.agency?.value,
    filter?.dateRange?.fromDate,
    filter?.dateRange?.toDate,
    filter.mda,
    filter?.positionType?.value,
  ]);

  const { countSeries, amountSeries, categories } = React.useMemo(
    () => convertToCategoriesAndSeries(payments),
    [payments]
  );

  return (
    <>
      {activeTab === "number" ? (
        <SupportTrendChartNumber series={countSeries} categories={categories} />
      ) : (
        <SupportTrendChartAmount
          series={amountSeries}
          categories={categories}
        />
      )}
    </>
  );
};

export default SupportTrend;
